// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","Image":"Footer_Image__t7DFZ","TextContainer":"Footer_TextContainer__efzMq"};